import { Components, Theme } from '@mui/material'
import alertTheme from './alert'
import button from './button'
import { chip, formLabel, menu, skeleton, slider, tablePagination, tooltip } from './misc'
import { inputLabel, outlinedInput, select, textField } from './input'

const components: Components<Theme> = {
  MuiTablePagination: tablePagination,
  MuiFormLabel: formLabel,
  MuiSkeleton: skeleton,
  MuiInputLabel: inputLabel,
  MuiTextField: textField,
  MuiSelect: select,
  MuiOutlinedInput: outlinedInput,
  MuiAlert: alertTheme(),
  MuiChip: chip,
  MuiButton: button,
  MuiMenu: menu,
  MuiTooltip: tooltip,
  MuiSlider: slider
}

export default components
